import {Penalty} from './penalty';
import {RunningTeamMember} from './running-team-member';
import {Catch} from './catch';
import {BonusLife} from "./bonus-life";

export class RunningTeam {

  id: string;
  name: string;
  teamNumber: number;
  group: string;
  category: string;
  status: RunningTeamStatus;

  noMembers: number;

  disqualificationReason?: string;
  checkInTime: Date;
  firstCatchTime?: Date;
  actualCheckInTime: Date; // Stores actual check-in time without any bonus time added

  noCatches: number;
  actualNoCatches: number; // Stores number without any bonus lives/penalties removed
  catches: Catch[];

  manager: string;

  contactName: string;
  contactPhone: string;
  contactEmail: string;
  contactAddress: string;

  penalties: Penalty[];
  bonusLives: BonusLife[];
  members: RunningTeamMember[];

  amountPaid: number;
}

export enum RunningTeamStatus {
  unregistered = 'Unregistered', // Teams initially signed up as this
  registered = 'Registered', // After registration, before game starts
  running = 'Running', // After game starts all registered teams are set as running - doesn't happen now!
  checkedIn = 'Checked-In', // After checkin
  disqualified = 'Disqualified', // Either retired or disqualified, disqualificationReason should be filled
  discarded = 'Discarded' // Didn't turn up to registration
}
